import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/jose/bg_jose.png';
import Photo1 from '../../../../../Images/modals/photographers/jose/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/jose/photo-2.png';
import Photo3 from '../../../../../Images/modals/photographers/jose/photo-3.png';

import {
  Photo_Jose,
  Text_Jose,
  TextPhoto1_Jose,
  TextPhoto2_Jose,
  TextPhoto3_Jose,
} from '../../../../../utils/EN/Modals/photographers';

const ModalJose = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-jose"
        mainBg={PhotoBg}
        directorName={Photo_Jose}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Jose}
        directorText={Text_Jose}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Jose}
        rowWidth1={'339px'}
        rowImage2={Photo3}
        videoText3={TextPhoto3_Jose}
        rowWidth2={'339px'}
        rowWidth3={'0px'}
        mainGallery={'jose-gallery-1'}
        gallery2={'jose-gallery-2'}
        gallery3={'jose-gallery-3'}
      />
    </>
  );
};

export default ModalJose;
